import { Box } from '@mui/material';
import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckboxField from '../fields/checkbox-field/checkbox-field.component';
import CurrencyField from '../fields/currency-field/currency-field.component';
import AmountTypeSelect from './amount-type-select/amount-type-select.component';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const OrderRefundForm = ({ orderData, orderDetails }) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();
  const fullAmount = useWatch({ name: 'fullAmount' });

  useEffect(() => {
    const refundAmount =
      (orderDetails?.orderTotal?.total -
        orderDetails?.orderTotal?.refundSummary?.totalRefundAmount) /
      1000;
    if (fullAmount === 'fullAmount') {
      setValue('refundAmount', refundAmount);
    } else {
      setValue('refundAmount', undefined);
    }
  }, [
    fullAmount,
    orderDetails?.orderTotal?.refundSummary?.totalRefundAmount,
    orderDetails?.orderTotal?.total,
    setValue,
  ]);

  return (
    <Box>
      <AmountTypeSelect name="fullAmount" orderData={orderData} />
      <CurrencyField
        name="refundAmount"
        label={t('forms.fields.refundForm.amount.label')}
        data-testid="RefundForm.RefundAmount"
        disabled={fullAmount === 'fullAmount' || fullAmount === undefined}
      />
      <IncTextField
        name="refundReason"
        label={t('forms.fields.refundForm.reason.label')}
        data-testid="RefundForm.RefundReason"
        multiline
      />
      <IncTextField
        name="requestedBy"
        label={t('forms.fields.refundForm.employeeName.label')}
        data-testid="RefundForm.EmployeeName"
      />
      <CheckboxField
        name="emailReceipt"
        label={t('forms.fields.refundForm.emailReceipt.label')}
        data-testid="RefundForm.CheckboxField"
        helperText={t('forms.fields.refundForm.emailReceipt.helperText')}
        helperTextSeverity="warning"
      />
    </Box>
  );
};

export default OrderRefundForm;
